import type {Metadata} from '@/views/Chat/types'

const THREAD_INFO_START = '```json\n'
const THREAD_INFO_END = '"}}```'

export default function getMetadataFromMessage(message: string, noParse = false) {
  if (!message.startsWith(THREAD_INFO_START)) {
    return {
      metadata: undefined,
      leftOverMessage: message,
    }
  }
  const endMetadataPos = message.indexOf(THREAD_INFO_END)
  if (endMetadataPos !== -1) {
    let metadata: Metadata | undefined

    if (!noParse) {
      const metadataRaw = message.slice(THREAD_INFO_START.length, endMetadataPos + 3)
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access -- its intentional
        metadata = (JSON.parse(metadataRaw) as any).metadata
      } catch (e) {
        console.error('Cannot parse metadata', metadataRaw, e)
      }
    }

    return {
      metadata,
      leftOverMessage: message.slice(endMetadataPos + THREAD_INFO_END.length + 1),
    }
  }
  return {
    metadata: undefined,
    leftOverMessage: '',
  }
}
